
import React from 'react';
import { useTranslation } from 'react-i18next';


export default function TvFavPackRemoveDialog(props) {
    const { t } = useTranslation('tvplan');

    return (
        <span>
            {t("fav_remove_msg_before")} :
            {props.children}{".  "}{t('fav_remove_msg_after')}
        </span>
    );
}